import { getLoginType } from '@/libs/until'

const state = {
  activityInspect: [],
  activityInspectDetail: {},
  // activityPublicCount: []
}
const	getters = {
  getActivityInspect: state => {
    return state.activityInspect;
  },
  getActivityInspectDetail: state => {
    return state.activityInspectDetail;
  },
}
const	mutations = {
  getactivityinspect(state, payload) {
    state.activityInspect = payload;
  },
  getactivityinspectdetail(state, payload) {
    state.activityInspectDetail = payload;
  },
  getactivitypubliccount(state, payload) {
    state.activityPublicCount = payload;
  }
}
const	actions = {
  
  reqActivityInspect( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/getAuditinglist",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getactivityinspect', result.data);
        r();
      }).catch(() => {
        j();
      })
    })    
  },

  reqActivityInspectDetail( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/getAuditingdetails",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        
        commit('getactivityinspectdetail', result.data)
        // console.log(result.data);
        
        r(result.data);
      }).catch(() => {
        j();
      })
    })
  },
  
  reqInspectActivity( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/saveAuditing",
        method: "post",
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json'
        },
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}